import { aiContextRegistry } from '../AIContextRegistry';

aiContextRegistry.register({
  id: 'portfolio',
  label: 'Portefeuille complet',
  description: 'Top 30 positions, valorisation, P&L',
  icon: '📊',
  tokens: ['$portfolio', '$ptf', '$portefeuille'],
  parameterized: false,
  examples: [
    { text: '@Claude analyse $portfolio' },
    { text: '@GPT quels sont les risques de $portfolio' },
  ],
});
